var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKeywords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.29 5.483a5.947 5.947 0 0 0-1.355 6.318l-8 8.001-.365 3.455 4.564-.782.191-2.1 2.1-.191.191-2.1 2.1-.191 2.655-2.655c2.12.806 4.611.353 6.319-1.354a5.94 5.94 0 0 0-8.4-8.4zm4.39 1.718a1.62 1.62 0 1 1 2.291 2.291 1.62 1.62 0 0 1-2.29-2.29z",
    fill: "#122442"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKeywords);
export default __webpack_public_path__ + "static/media/icon-keywords.e35a6d51.svg";
export { ForwardRef as ReactComponent };